export enum MajorCardId {
	CHARIOT = 'CHARIOT',
	DEATH = 'DEATH',
	DEVIL = 'DEVIL',
	EMPEROR = 'EMPEROR',
	EMPRESS = 'EMPRESS',
	FOOL = 'FOOL',
	HANGED_MAN = 'HANGED_MAN',
	HERMIT = 'HERMIT',
	HIEROPHANT = 'HIEROPHANT',
	HIGH_PRIESTESS = 'HIGH_PRIESTESS',
	JUDGEMENT = 'JUDGEMENT',
	JUSTICE = 'JUSTICE',
	LOVERS = 'LOVERS',
	MAGICIAN = 'MAGICIAN',
	MOON = 'MOON',
	STAR = 'STAR',
	STRENGTH = 'STRENGTH',
	SUN = 'SUN',
	TEMPERANCE = 'TEMPERANCE',
	TOWER = 'TOWER',
	WHEEL_OF_FORTUNE = 'WHEEL_OF_FORTUNE',
	WORLD = 'WORLD'
}

type CloudinaryPaths = {
	front: string;
	back: string;
};

type BaseCardSpec = {
	_tag: string;
	cloudinaryPaths: CloudinaryPaths;
};

export type MajorCardSpec = BaseCardSpec & {
	_tag: 'MajorCardSpec';
	id: MajorCardId;
};

export type MinorCardSpec = BaseCardSpec & {
	_tag: 'MinorCardSpec';
	suit: Suit;
	id: MinorCardId;
	hasNumber: (num: MinorCardNumber) => boolean;
	nextNumber: MinorCardNumber | null;
	isCourtCard: boolean;
};

export type AnyCardSpec = MajorCardSpec | MinorCardSpec;

export enum TimeOfDay {
	DAY = 'DAY',
	NIGHT = 'NIGHT'
}

export enum MinorCardNumber {
	ONE = 'ONE',
	TWO = 'TWO',
	THREE = 'THREE',
	FOUR = 'FOUR',
	FIVE = 'FIVE',
	SIX = 'SIX',
	SEVEN = 'SEVEN',
	EIGHT = 'EIGHT',
	NINE = 'NINE',
	TEN = 'TEN',
	PAGE = 'PAGE',
	KNIGHT = 'KNIGHT',
	QUEEN = 'QUEEN',
	KING = 'KING'
}

export type AnyCardId = MajorCardId | MinorCardId;

export enum MajorDisplayState {
	SAVED = 'SAVED',
	DISMISSED = 'DISMISSED'
}

export enum Arcana {
	MAJOR = 'MAJOR',
	MINOR = 'MINOR'
}

export enum Suit {
	SWORD = 'SWORD',
	CUPS = 'CUPS',
	STAVES = 'STAVES',
	COINS = 'COINS'
}

export enum GameStage {
	CHOOSE_INITIAL_DEITY = 'CHOOSE_INITIAL_DEITY',
	MAIN_GAME = 'MAIN_GAME'
}

export enum MinorCardId {
	COINS_ONE = `${Suit.COINS}_${MinorCardNumber.ONE}`,
	COINS_TWO = `${Suit.COINS}_${MinorCardNumber.TWO}`,
	COINS_THREE = `${Suit.COINS}_${MinorCardNumber.THREE}`,
	COINS_FOUR = `${Suit.COINS}_${MinorCardNumber.FOUR}`,
	COINS_FIVE = `${Suit.COINS}_${MinorCardNumber.FIVE}`,
	COINS_SIX = `${Suit.COINS}_${MinorCardNumber.SIX}`,
	COINS_SEVEN = `${Suit.COINS}_${MinorCardNumber.SEVEN}`,
	COINS_EIGHT = `${Suit.COINS}_${MinorCardNumber.EIGHT}`,
	COINS_NINE = `${Suit.COINS}_${MinorCardNumber.NINE}`,
	COINS_TEN = `${Suit.COINS}_${MinorCardNumber.TEN}`,
	COINS_PAGE = `${Suit.COINS}_${MinorCardNumber.PAGE}`,
	COINS_KNIGHT = `${Suit.COINS}_${MinorCardNumber.KNIGHT}`,
	COINS_QUEEN = `${Suit.COINS}_${MinorCardNumber.QUEEN}`,
	COINS_KING = `${Suit.COINS}_${MinorCardNumber.KING}`,

	SWORD_ONE = `${Suit.SWORD}_${MinorCardNumber.ONE}`,
	SWORD_TWO = `${Suit.SWORD}_${MinorCardNumber.TWO}`,
	SWORD_THREE = `${Suit.SWORD}_${MinorCardNumber.THREE}`,
	SWORD_FOUR = `${Suit.SWORD}_${MinorCardNumber.FOUR}`,
	SWORD_FIVE = `${Suit.SWORD}_${MinorCardNumber.FIVE}`,
	SWORD_SIX = `${Suit.SWORD}_${MinorCardNumber.SIX}`,
	SWORD_SEVEN = `${Suit.SWORD}_${MinorCardNumber.SEVEN}`,
	SWORD_EIGHT = `${Suit.SWORD}_${MinorCardNumber.EIGHT}`,
	SWORD_NINE = `${Suit.SWORD}_${MinorCardNumber.NINE}`,
	SWORD_TEN = `${Suit.SWORD}_${MinorCardNumber.TEN}`,
	SWORD_PAGE = `${Suit.SWORD}_${MinorCardNumber.PAGE}`,
	SWORD_KNIGHT = `${Suit.SWORD}_${MinorCardNumber.KNIGHT}`,
	SWORD_QUEEN = `${Suit.SWORD}_${MinorCardNumber.QUEEN}`,
	SWORD_KING = `${Suit.SWORD}_${MinorCardNumber.KING}`,

	STAVES_ONE = `${Suit.STAVES}_${MinorCardNumber.ONE}`,
	STAVES_TWO = `${Suit.STAVES}_${MinorCardNumber.TWO}`,
	STAVES_THREE = `${Suit.STAVES}_${MinorCardNumber.THREE}`,
	STAVES_FOUR = `${Suit.STAVES}_${MinorCardNumber.FOUR}`,
	STAVES_FIVE = `${Suit.STAVES}_${MinorCardNumber.FIVE}`,
	STAVES_SIX = `${Suit.STAVES}_${MinorCardNumber.SIX}`,
	STAVES_SEVEN = `${Suit.STAVES}_${MinorCardNumber.SEVEN}`,
	STAVES_EIGHT = `${Suit.STAVES}_${MinorCardNumber.EIGHT}`,
	STAVES_NINE = `${Suit.STAVES}_${MinorCardNumber.NINE}`,
	STAVES_TEN = `${Suit.STAVES}_${MinorCardNumber.TEN}`,
	STAVES_PAGE = `${Suit.STAVES}_${MinorCardNumber.PAGE}`,
	STAVES_KNIGHT = `${Suit.STAVES}_${MinorCardNumber.KNIGHT}`,
	STAVES_QUEEN = `${Suit.STAVES}_${MinorCardNumber.QUEEN}`,
	STAVES_KING = `${Suit.STAVES}_${MinorCardNumber.KING}`,

	CUPS_ONE = `${Suit.CUPS}_${MinorCardNumber.ONE}`,
	CUPS_TWO = `${Suit.CUPS}_${MinorCardNumber.TWO}`,
	CUPS_THREE = `${Suit.CUPS}_${MinorCardNumber.THREE}`,
	CUPS_FOUR = `${Suit.CUPS}_${MinorCardNumber.FOUR}`,
	CUPS_FIVE = `${Suit.CUPS}_${MinorCardNumber.FIVE}`,
	CUPS_SIX = `${Suit.CUPS}_${MinorCardNumber.SIX}`,
	CUPS_SEVEN = `${Suit.CUPS}_${MinorCardNumber.SEVEN}`,
	CUPS_EIGHT = `${Suit.CUPS}_${MinorCardNumber.EIGHT}`,
	CUPS_NINE = `${Suit.CUPS}_${MinorCardNumber.NINE}`,
	CUPS_TEN = `${Suit.CUPS}_${MinorCardNumber.TEN}`,
	CUPS_PAGE = `${Suit.CUPS}_${MinorCardNumber.PAGE}`,
	CUPS_KNIGHT = `${Suit.CUPS}_${MinorCardNumber.KNIGHT}`,
	CUPS_QUEEN = `${Suit.CUPS}_${MinorCardNumber.QUEEN}`,
	CUPS_KING = `${Suit.CUPS}_${MinorCardNumber.KING}`
}

export type MajorArcanaContent = {
	name: string;
	boon: string[];
	bane: string[];
};
